import { createContext, useContext } from 'react';

export function createStrictContext<T>() {
  const Context = createContext<T | null>(null);

  function useStrictContext() {
    const contextValue = useContext(Context);
    if (contextValue === null) {
      throw new Error('context must be used within a Provider');
    }
    return contextValue;
  }

  return [useStrictContext, Context] as const;
}
